var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"omapi-featured-in"},[_c('h2',[_vm._v("OptinMonster has been featured in:")]),_c('img',{attrs:{"src":require("../../../assets/images/welcome/featured-in-logos.svg"),"alt":"Feauted in Inc., Forbes, VB, Yahoo!, Entrepreneur, and Huffpost!"}})])
}]

export { render, staticRenderFns }